import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import usePlayerData from 'src/hooks/usePlayerData';
import ApplicationService from 'src/services/ApplicationService';
import {
  PlaybackActionTypes,
  SELECTOR_PLAYBACK_FIRST_PLAY,
  SELECTOR_PLAYBACK_READY,
} from 'src/store/reducers/playback';
import { AutoplayActionTypes } from 'src/store/reducers/autoplay';
import { MarkerActionTypes } from 'src/store/reducers/marker';
import useUserPreferences from 'src/hooks/useUserPreferences';
import useSubtitle from 'src/hooks/useSubtitle';
import SubtitleService from 'src/services/SubtitleService';
import { SubtitlesActionTypes } from 'src/store/reducers/subtitles';
import browserUtils from 'src/utils/browserUtils';

function useLoadUserPreferences() {
  const ready = useSelector(SELECTOR_PLAYBACK_READY);
  const firstPlay = useSelector(SELECTOR_PLAYBACK_FIRST_PLAY);
  const { detectAndroid } = browserUtils;

  const {
    playerData: { live, currentTime },
  } = usePlayerData();

  const dispatch = useDispatch();
  const { getDefaultSubtitleLanguage } = useSubtitle();
  const { autoplayEnabled, markerPreviewEnabled, playbackRate, volumePercent, subtitle } = useUserPreferences();

  useEffect(() => {
    dispatch({ type: AutoplayActionTypes.SET_AUTOPLAY_ENABLED, payload: autoplayEnabled });
    dispatch({ type: MarkerActionTypes.SET_MARKER_PREVIEW, payload: markerPreviewEnabled });
    !live && dispatch({ type: PlaybackActionTypes.SET_PLAYBACK_RATE, payload: playbackRate });
    dispatch({ type: SubtitlesActionTypes.SET_SUBTITLE_STYLE, payload: subtitle.style });
  }, []);

  useEffect(() => {
    if (!ready || !ApplicationService.player) return;

    currentTime && ApplicationService.player.setCurrentTime(currentTime);

    !live && ApplicationService.player.setPlaybackRate(playbackRate);

    ApplicationService.player?.setVolumePercent(detectAndroid() ? 100 : volumePercent);
  }, [ready]);

  useEffect(() => {
    if (!firstPlay) return;
    if (subtitle.enabled) {
      const defaultSubtitleLanguage = getDefaultSubtitleLanguage();
      SubtitleService.setActiveSubtitle(defaultSubtitleLanguage || '');
    }
  }, [firstPlay, getDefaultSubtitleLanguage, subtitle.enabled]);
}

export default useLoadUserPreferences;
